import CustomView from '../CustomView'
import TableRow from './TableRow'

import { IBody } from '@/types/customTable.types'

function TableBody({
  dataset,
  actions,
  columnsId,
  showSelectColumn,
  canChoiceOnlyOneSelect,
  selectionMatchFields,
  selectionConstraintMessage,
  handleAction,
  overrideAction,
  allowEditInactive,
  rowDisabled
}: IBody) {
  return (
    <CustomView backColor="white" maxHeight={508}>
      {dataset?.map((data: any, index) => (
        <CustomView
          key={index}
          style={{ background: index % 2 == 0 ? '#F8F8F8' : 'transparent' }}
          flexDirection="row"
          alignItems="center"
          position="relative"
          backColor={
            rowDisabled && typeof data?.solicitation == 'number'
              ? 'disabled'
              : 'default'
          }
        >
          <TableRow
            data={data}
            action={actions}
            columnsId={columnsId}
            index={index}
            showSelectColumn={showSelectColumn}
            canChoiceOnlyOneSelect={canChoiceOnlyOneSelect}
            selectionMatchFields={selectionMatchFields}
            selectionConstraintMessage={selectionConstraintMessage}
            handleAction={handleAction}
            overrideAction={overrideAction}
            allowEditInactive={allowEditInactive}
            selectDisabled={rowDisabled && typeof data.solicitation == 'number'}
            openActionsUpward={index >= (dataset?.length ?? 0) - 3}
          />
        </CustomView>
      ))}
    </CustomView>
  )
}
export default TableBody
